import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { ISimple } from '@noda-lib/utils/interfaces';
import { ArticlesListImports } from '@pages/articles/list/articles-list.imports';
import { LanguageService } from '@translate/services/language.service';

import { IArticle } from '../interfaces/article.interface';

@Component({
  selector: 'noda-articles-list',
  standalone: true,
  templateUrl: './articles-list.component.html',
  styleUrls: ['./articles-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ArticlesListImports,
})
export class ArticlesListComponent {
  public articles: InputSignal<IArticle[]> = input<IArticle[]>([]);
  public changePage: OutputEmitterRef<number> = output<number>();

  constructor(private langService: LanguageService) {}

  public getImageUrl(article: IArticle): string {
    return article.preview.background.image.data?.attributes.url;
  }

  public getIconUrl(article: IArticle): string {
    return article.preview.background.icon.data?.attributes.url;
  }

  public getBackgroundColor(article: IArticle): string {
    return article.preview.background.color;
  }

  public getColorBlack(article: IArticle): boolean {
    return article.preview.colorTextIsBlack;
  }

  public getBadgeClasses(article: IArticle): ISimple<boolean> {
    return {
      'bg-dark': !!article.preview.background.image.data?.attributes.url,
      neutral: article.preview.colorTextIsBlack,
    };
  }

  public getLang(article: IArticle): string {
    if (this.isArticleLangMatchesSiteLang(article)) {
      return article.path;
    } else {
      return `/articles/${article.path}`;
    }
  }

  private isArticleLangMatchesSiteLang(article: IArticle): boolean {
    return article.language.data.attributes.value === this.langService.activeLang;
  }
}
